import { CardTablePagination } from "@/features/analytics/builder/engine/components/CardTablePagination";
import { ADMIN_TABLE_PAGE_SIZE } from "./types";

interface AdminTablePaginationProps {
    page: number;
    totalCount: number;
    pageSize?: number;
    onPageChange: (page: number) => void;
    isFetching?: boolean;
}

/** Server-page pagination with "Showing X–Y of Z" summary. */
export function AdminTablePagination({
    page,
    totalCount,
    pageSize = ADMIN_TABLE_PAGE_SIZE,
    onPageChange,
    isFetching = false,
}: AdminTablePaginationProps) {
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
    const from = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, totalCount);

    return (
        <div className="flex flex-col items-center gap-1">
            <p className="text-muted-foreground text-xs" aria-live="polite">
                {totalCount === 0 ? "No rows" : `Showing ${from}–${to} of ${totalCount}${isFetching ? "…" : ""}`}
            </p>
            <CardTablePagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
    );
}
